/**
 * MAMPE Konfigurator — Latin-Hint Injection
 * ----------------------------------------------------------------------------
 * Verschiebt den Hinweis "nur lateinische Buchstaben" aus dem versteckten
 * <template> in das von Teeinblue asynchron gerenderte Formular, und zwar
 * ZWISCHEN "Bild hochladen" (.tee-field--photo) und "Text Zeile 1"
 * (erstes .tee-field--text).
 *
 * Warum Observer? Teeinblue rendert das Form erst zur Laufzeit und kann es
 * re-rendern. Ein einfaches Einfügen beim Load reicht nicht zuverlässig.
 * Der MutationObserver auf dem Form-Container injiziert den Hinweis sobald
 * .tee-field--photo existiert und erneut, falls er verschwindet.
 *
 * Robustheit: Selektor ist der generische Typ-Klassenname (.tee-field--photo),
 * NICHT die numerische Layer-ID (z.B. tee-field--layer-377627), die sich pro
 * Template/Produkt unterscheiden kann.
 */
(function () {
  'use strict';

  function injectHint(container) {
    var templateId = container.getAttribute('data-latin-hint-template');
    if (!templateId) return;
    var tpl = document.getElementById(templateId);
    if (!tpl || !tpl.content) return;

    var photoField = container.querySelector('.tee-field--photo');
    if (!photoField) return;

    // Bereits injiziert? (direkter Nachfolger des photo-fields)
    var next = photoField.nextElementSibling;
    if (next && next.classList && next.classList.contains('konfigurator-hint')) return;

    var node = tpl.content.firstElementChild ? tpl.content.firstElementChild.cloneNode(true) : null;
    if (!node) return;

    photoField.insertAdjacentElement('afterend', node);
  }

  function observe(container) {
    injectHint(container);
    var observer = new MutationObserver(function () { injectHint(container); });
    observer.observe(container, { childList: true, subtree: true });
  }

  function init() {
    var containers = document.querySelectorAll('[data-latin-hint-template]');
    containers.forEach(function (c) {
      if (!c._latinHintObserved) { c._latinHintObserved = true; observe(c); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
